import React, { useState, useEffect } from 'react';
import './fadeIn.css'; // Make sure to import the CSS file

const FadeInText = ({ text,count}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, count); // Delay before the text fades in

    return () => clearTimeout(timer);
  }, [count]);

  return (
    <div className={`fade-in ${visible ? 'visible' : ''}`}>
      {text}
    </div>
  );
};

export default FadeInText;